import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react';
import { useSelectedObject } from '../hooks/useSelectedObject';
import { originSchema, topLevelElements } from '../constants/schema';

interface NavigationContextType {
  selectedTopNavigation: string;
  setSelectedTopNavigation: React.Dispatch<React.SetStateAction<string>>;
}

const NavigationContext = createContext<NavigationContextType>({
  selectedTopNavigation: '',
  setSelectedTopNavigation: () => {},
});

export const NavigationContextProvider = ({ children }: PropsWithChildren) => {
  const { isObjectSelected } = useSelectedObject();

  const [selectedTopNavigation, setSelectedTopNavigation] = useState<string>(
    topLevelElements.filter((path) => isObjectSelected(path.name))?.[0]?.name ?? originSchema.required?.[0] ?? ''
  );

  const state = {
    selectedTopNavigation,
    setSelectedTopNavigation,
  };

  return <NavigationContext.Provider value={state}>{children}</NavigationContext.Provider>;
};

export const useNavigationContext = () => {
  const context = useContext(NavigationContext);

  if (!context) {
    throw new Error('useBlankContext must be used within a BlankContextProvider');
  }
  return context;
};
